module.exports = __webpack_public_path__ + "static/media/IMG1.3c0720f0.png";